import { render, staticRenderFns } from "./LaudosPrazoEntrega.vue?vue&type=template&id=18fcdd3b&"
import script from "./LaudosPrazoEntrega.vue?vue&type=script&lang=js&"
export * from "./LaudosPrazoEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports